<div class="container-fluid">
  <!-- Page Heading -->
  <div class="page-heading mb-4">
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-trash-alt"></i> Tất cả sách bị hủy
    </h1>
    <p class="mb-4">Mô-đun này hiển thị tất cả các sách bị hủy và cho phép bạn quản lý chúng một cách hiệu quả.</p>
  </div>

  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <app-statistics-book
      (result)="filter($event)"
    ></app-statistics-book>

    <!-- DataTables Example -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <app-destroyed-books-list
            (idEvent)="edit($event)"
            (viewEvent)="view($event)"
            (deleteEvent)="delete($event)"
            [books]="books$"
          ></app-destroyed-books-list>
          <app-modal-book [id]="id"></app-modal-book>
        </div>
      </div>
    </div>
  </ng-template>
</div>

